import { render, staticRenderFns } from "./PlaySidebar.vue?vue&type=template&id=45831385&scoped=true"
import script from "./PlaySidebar.vue?vue&type=script&lang=js"
export * from "./PlaySidebar.vue?vue&type=script&lang=js"
import style0 from "./PlaySidebar.vue?vue&type=style&index=0&id=45831385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45831385",
  null
  
)

export default component.exports